import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { bodyTypeAsync } from "../../thunks/bodyType.thunk";

export interface CounterState {
  isResetLogin: boolean;
  loading: boolean;
  bodyTypeData:any[]
  errorMessage:string
}

const initialState: CounterState = {
  isResetLogin: false,
  loading: false,
  bodyTypeData:[],
  errorMessage:""
};

export const executiveLoginReudcer = createSlice({
  name: "login",
  initialState,
  reducers: {
    toggleResetLogin: (state) => {
      state.isResetLogin = !state.isResetLogin;
    },
    setError: (state:any, action: PayloadAction<string>) => {
      state.errorMessage = action.payload;
    },
    removeError:(state)=>{
      state.errorMessage=""
    }
  },  
  extraReducers:(builder)=>{
    builder.addCase(bodyTypeAsync.pending,()=>{
    }).addCase(bodyTypeAsync.fulfilled,(state:any,action)=>{
      state.bodyTypeData=state.data

    }).addCase(bodyTypeAsync.rejected,(data:CounterState,error:any)=>{
      data.errorMessage=error?.message || "Something went wrong"
    })
  }
});

// Action creators are generated for each case reducer function
export const { toggleResetLogin,removeError,setError } = executiveLoginReudcer.actions;

export default executiveLoginReudcer.reducer;
